// extracted by mini-css-extract-plugin
export default {"coevalBtn":"CoevaluationUserItem_coevalBtn__3pYVE","item":"CoevaluationUserItem_item__i8iyw","title":"CoevaluationUserItem_title__Vw6ue"};